import { ForbiddenError } from "./ForbiddenError.js";
class RefNotFoundError extends ForbiddenError {}
export { RefNotFoundError };
